export interface BusinessShedule {
    paymentDay?: number;
    paymentAllWeeks?: boolean;
    consolidationCriteriaCode?: string;
    customerComments?: string;
}


export interface DocummentType {
    consolidationCriteria: Array<ConsolidationCriteria>;
}
export interface ConsolidationCriteria {
    consolidationCriteriaCode?: string;
    consolidationCriteriaDesc?: string;
}
